module.exports = __webpack_public_path__ + "static/img/circle.30f080c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/circle.png
// module id = sf4E
// module chunks = 1